import React from "react";
import PageContainerWithLogo from '../Core/PageContainerWithLogo';
import '../../css/termsOfService.css';

export default function TermsOfService()
{
  return (
    <PageContainerWithLogo>
      <div className="terms-page">
        <div className="terms-container">
          <h1>Terms of Service</h1>
          <p className="updated">Last updated: December 2025</p>

          <p>
            These Terms of Service ("Terms") govern your use of <strong>Tilefolk.io</strong> (the "Service")
            operated by us ("we", "us", or "our"). By accessing or using our Service, you agree to be bound by these Terms.
          </p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By creating an account or using Tilefolk.io, you agree to these Terms and our Privacy Policy.
            If you do not agree, please do not use the Service.
          </p>

          <h2>2. Description of Service</h2>
          <p>
            Tilefolk.io is an online multiplayer platform for playing Carcassonne and potentially other board games.
            The Service is provided free of charge and is intended for entertainment purposes.
          </p>

          <h2>3. User Accounts</h2>
          <h3>A. Account Creation</h3>
          <p>
            You may create an account using supported social login providers (such as Google).
            You are responsible for maintaining the security of your account.
          </p>

          <h3>B. Account Conduct</h3>
          <p>You agree not to:</p>
          <ul>
            <li>Use offensive, inappropriate, or harmful usernames or content</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Cheat, exploit bugs, or use automated tools</li>
            <li>Share your account with others</li>
            <li>Attempt to gain unauthorized access to the Service</li>
          </ul>

          <h2>4. Intellectual Property</h2>
          <p>
            The original Carcassonne game is owned by Hans im Glück Verlags-GmbH and Z-Man Games.
            This is a fan-made implementation for educational and entertainment purposes.
            All game assets and rules belong to their respective copyright holders.
          </p>
          <p>
            The Tilefolk.io software, website design, and original content are protected by copyright and other intellectual property laws.
          </p>

          <h2>5. Privacy and Data</h2>
          <p>
            Your privacy is important to us. Our collection and use of your personal information is governed by our Privacy Policy,
            which is incorporated into these Terms by reference.
          </p>

          <h2>6. Disclaimers</h2>
          <p>
            The Service is provided "as is" without warranties of any kind. We do not guarantee that the Service will be:
          </p>
          <ul>
            <li>Always available or uninterrupted</li>
            <li>Free from bugs or errors</li>
            <li>Secure from unauthorized access</li>
            <li>Compatible with all devices or browsers</li>
          </ul>

          <h2>7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, we shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages arising from your use of the Service.
          </p>

          <h2>8. Termination</h2>
          <p>
            We may terminate or suspend your account at any time for violations of these Terms or for any other reason.
            You may also delete your account at any time through the Service.
          </p>

          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of significant changes
            by posting the updated Terms on the website with a new "Last updated" date.
          </p>

          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of England and Wales.
            Any disputes shall be resolved in the courts of England and Wales.
          </p>

          <h2>11. Contact Information</h2>
          <p>
            If you have questions about these Terms, please contact us at{ ' ' }
            <a href="mailto:help@tilefolk.io">help@tilefolk.io</a>.
          </p>

        </div>
      </div>
    </PageContainerWithLogo>
  );
}
